import 'magnific-popup';
import 'slick-carousel';
import moment from 'moment';

jQuery( document ).ready(function($) {

    $('.mfp-image').magnificPopup({
        type: 'image'
    });
    
    $('.scroll').on('click', function(e) {
        e.preventDefault();
        const scrollTop = $($(this).attr('href')).position().top;
        $('html, body').animate({ scrollTop });
    })

    $('.slider-videos').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-arrow-left"></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fas fa-arrow-right"></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
    });

    $('.seeall-btn').on('click', function(e){
        e.preventDefault();
        $('#events').addClass('seeall');
        $(this).hide();
    });

    $.ajax( {
        url: 'https://rest.bandsintown.com/artists/Ashthon Jones/events?app_id=45PRESS_ashthon',
        method: 'GET',
        dataType: 'json',
        error: () => {
          alert( 'Error fetching events!' );
        },
        success: data => {
        const events = $( '#events' );
        let html = '';
        if ( data.length ) {
          for ( let event of data ) {
            let region = event.venue.region?event.venue.region:event.venue.country;
            let location = event.venue.city + ', ' + region;
            if ( location === ', ' ) {location = '';}
            if ( event.venue.name.toLowerCase() === 'streaming live' ) {location = 'Online';}
            html += '<div class="event">';
            html += '<div class="event-date">' + moment( event.datetime ).format( 'MMM DD, Y' ) + '</div>';
            html += '<div class="event-venue">' + event.venue.name + '</div>';
            html += '<div class="event-location">' + location + '</div>';
            html += '<div class="event-links">';
            for ( let offer of event.offers ) {
              html += '<a href="' + offer.url + '" target="_blank" class="btn">' + offer.type + '</a>';
            }
            html += '</div>';
            html += '</div>';
          }
          events.html( html );
          } else {
            events.html( '<p class="no-event">Check Back for Event Updates</p>' );
            $('.seeall-btn').hide();
          } 
        }
    });

    $.ajax({
        url: 'https://www.juicer.io/api/feeds/ashthonjones/',
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            console.log(data);
            let c = 1;
            let html = '';
            for (let item of data.posts.items) {
                
                if (item.unformatted_message != null){
                    var text = '';
                } else{
                    var text = " ";
                }
                const img = item.image;
                if (img) { 
                    
                    html += `
                            <div>
                                <a href="${item.full_url}" target="_blank" style="background-image: url('${img}');">
                                    <span>${text}</span>
                                </a>
                            </div>
                        `;
                } else {
                    html += `
                            <div>
                                <a href="${item.full_url}" target="_blank">
                                    <span style="opacity: 1;">${text}</span>
                                </a>
                            </div>
                        `;
                }
                if (c++ >= 8) {
                    $('#feed').html(html);
                    return false;
                }
            }
            $('#feed').html(html);
        },
        error: function () {
            console.log('Error loading feed.');
        }
    });
    
});